import { render } from "./AssetView.vue?vue&type=template&id=f8dd0880"
import script from "./AssetView.vue?vue&type=script&lang=js"
export * from "./AssetView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/50sunset/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__